import React, { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import AndroidRoundedIcon from '@mui/icons-material/AndroidRounded';
import AppleIcon from '@mui/icons-material/Apple';
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import LaptopMacRoundedIcon from '@mui/icons-material/LaptopMacRounded';
import TvRoundedIcon from '@mui/icons-material/TvRounded';
import WindowRoundedIcon from '@mui/icons-material/WindowRounded';
import { SERIES_PLATFORMS } from './userPanelSeriesData';
import { resolveKnownSeriesPlatformId, sortSeriesNewestFirst } from './userPanelSeriesOrdering';
import './userPanelHomeShowcases.css';

export const APP_PLATFORMS = [
  {
    id: 'windows', name: 'Windows', subtitle: 'Masaüstü', icon: WindowRoundedIcon,
    title: 'Büyük ekranda tam kontrol.', counter: '01 / 05 · WINDOWS',
    description: 'Tivigo IPTV paketini Windows için kendi geliştirdiğimiz uygulamada aç; canlı TV, film ve dizilere başka bir oynatıcıya ihtiyaç duymadan ulaş.',
    points: ['Tivigo’ya özel Windows uygulaması', 'Canlı TV, film ve dizi tek yerde', 'Windows 10 ve 11 desteği'],
    main: '/assets/images/product/windows-dashboard-tour-v6.mp4', detailOne: '/assets/images/product/windows-film-detail.jpg',
    detailTwo: '/assets/images/product/windows-series-detail.jpg', color: '#ff8a1f', rgb: '255, 138, 31',
    mainSize: [1280, 764], detailOneSize: [960, 600], detailTwoSize: [960, 530], mediaType: 'video',
    poster: '/assets/images/product/windows-home.jpg',
    mainLabel: 'Ana ekran', detailOneLabel: 'Film detayı', detailTwoLabel: 'Dizi detayı',
    cta: 'Windows için indir', setupDetailId: 'tivigo-pc',
  },
  {
    id: 'android', name: 'Android', subtitle: 'Telefon ve TV', icon: AndroidRoundedIcon,
    title: 'Her şey, tek dokunuşta.', counter: '02 / 05 · ANDROID',
    description: 'Tivigo IPTV paketini Android telefon ve TV’ler için geliştirdiğimiz özel uygulamada izle; yayınlarına başka bir oynatıcıya ihtiyaç duymadan bağlan.',
    points: ['Tivigo’ya özel Android uygulaması', 'Canlı TV, film ve dizi tek yerde', 'Telefon ve Android TV desteği'],
    main: '/assets/images/product/android-tour-20260713.mp4', detailOne: null,
    dashboardBanner: '/assets/images/product/tivigo-android-dashboard-banner.png',
    dashboardBannerSize: [1134, 255], dashboardBannerLabel: 'Resmi Tivigo Android uygulaması',
    detailTwo: null, color: '#5de0a3', rgb: '93, 224, 163', mobile: true, tour: true, mediaType: 'video',
    mainSize: [360, 802],
    mainLabel: 'Gerçek uygulama turu',
    cta: 'Google Play’den indir', setupDetailId: 'tivigo',
  },
  {
    id: 'ios', name: 'iOS', subtitle: 'iPhone ve iPad', icon: AppleIcon,
    title: 'Her an, her yerde seninle.', counter: '03 / 05 · IOS',
    description: 'IPTV paketini iPhone ve iPad için tasarladığımız Tivigo uygulamasında kullan; canlı yayın ve içerik arşivine sade, hızlı bir deneyimle eriş.',
    points: ['Tivigo’ya özel iOS uygulaması', 'Canlı TV ve içerik arşivi', 'iPhone ve iPad desteği'],
    main: '/assets/images/product/android-tour-20260713.mp4', detailOne: null,
    dashboardBanner: '/assets/images/product/tivigo-ios-dashboard-banner.png',
    dashboardBannerSize: [1134, 255], dashboardBannerLabel: 'Resmi Tivigo iOS uygulaması',
    detailTwo: null, color: '#7c66ff', rgb: '124, 102, 255', mobile: true, tour: true, mediaType: 'video',
    mainSize: [360, 802],
    mainLabel: 'Gerçek uygulama turu',
    cta: 'Çok yakında.', comingSoon: true, setupAvailable: false,
  },
  {
    id: 'lg', name: 'LG webOS', subtitle: 'Smart TV', icon: TvRoundedIcon,
    title: 'TV’nin yeni ana ekranı.', counter: '04 / 05 · LG WEBOS',
    description: 'Tivigo IPTV paketini LG webOS için geliştirdiğimiz Smart TV uygulamasında aç; harici kutu veya farklı bir oynatıcı olmadan izlemeye başla.',
    points: ['Tivigo’ya özel LG webOS uygulaması', 'Kumanda dostu Smart TV deneyimi', 'Canlı TV, film ve dizi erişimi'],
    main: '/assets/images/product/lg-home.jpg', detailOne: '/assets/images/product/lg-film-detail.jpg',
    detailTwo: null, color: '#ff4e88', rgb: '255, 78, 136',
    mainSize: [1440, 626], detailOneSize: [1440, 810],
    mainLabel: 'TV ana ekranı', detailOneLabel: 'Film detayı',
    cta: 'Çok yakında.', comingSoon: true, setupAvailable: false,
  },
  {
    id: 'macos', name: 'macOS', subtitle: 'Mac', icon: LaptopMacRoundedIcon,
    title: 'Masaüstünde daha fazlası.', counter: '05 / 05 · MACOS',
    description: 'Tivigo IPTV paketini macOS için geliştirdiğimiz masaüstü uygulamasında kullan; yayınlarını ve içerik arşivini tek, modern bir deneyimde yönet.',
    points: ['Tivigo’ya özel macOS uygulaması', 'Canlı yayın ve içerik arşivi', 'Mac için modern masaüstü deneyimi'],
    main: '/assets/images/product/windows-dashboard-tour-v6.mp4', detailOne: '/assets/images/product/windows-film-detail.jpg',
    detailTwo: '/assets/images/product/windows-series-detail.jpg', color: '#63c7ff', rgb: '99, 199, 255',
    mainSize: [1280, 764], detailOneSize: [960, 600], detailTwoSize: [960, 530], mediaType: 'video',
    poster: '/assets/images/product/windows-home.jpg',
    mainLabel: 'macOS uygulaması', detailOneLabel: 'Film detayı', detailTwoLabel: 'Dizi detayı',
    cta: 'macOS için indir', setupDetailId: 'tivigo-macos',
  },
];

const APP_PLATFORM_ORDER = ['android', 'windows', 'ios', 'lg', 'macos'];
APP_PLATFORMS.sort((first, second) => (
  APP_PLATFORM_ORDER.indexOf(first.id) - APP_PLATFORM_ORDER.indexOf(second.id)
));
APP_PLATFORMS.forEach((platform, index) => {
  const currentIndex = String(index + 1).padStart(2, '0');
  const totalCount = String(APP_PLATFORMS.length).padStart(2, '0');
  platform.counter = platform.counter.replace(/^\d{2} \/ \d{2}/, `${currentIndex} / ${totalCount}`);
});

const handleTabKeyDown = (event, items, activeId, activate) => {
  const supportedKeys = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End'];
  if (!supportedKeys.includes(event.key)) return;

  event.preventDefault();
  const currentIndex = Math.max(0, items.findIndex((item) => item.id === activeId));
  let nextIndex = currentIndex;

  if (event.key === 'Home') nextIndex = 0;
  else if (event.key === 'End') nextIndex = items.length - 1;
  else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % items.length;
  else nextIndex = (currentIndex - 1 + items.length) % items.length;

  activate(items[nextIndex].id);
  window.requestAnimationFrame(() => {
    event.currentTarget.parentElement?.querySelectorAll('[role="tab"]')?.[nextIndex]?.focus();
  });
};

const hasOnlyLatinTitleLetters = (value) => Array.from(String(value || '')).every((character) => (
  !/\p{Letter}/u.test(character) || /\p{Script=Latin}/u.test(character)
));

const buildSeriesShowcasePlatforms = (series) => {
  const normalizedSeries = (Array.isArray(series) ? series : []).map((item, index) => {
    const rawPlatformId = String(item.platformId || item.platform_id || item.category_id || 'tivigo');
    const platformName = item.platformName || item.platform || item.category_name || '';
    const platformId = resolveKnownSeriesPlatformId(platformName)
      || resolveKnownSeriesPlatformId(rawPlatformId)
      || rawPlatformId;

    return {
      id: String(item.id || item.series_id || `${platformId}-${index}`),
      series_id: item.series_id || item.id,
      title: String(item.name || item.title || 'İsimsiz dizi'),
      meta: item.genre || item.meta || platformName || 'Dizi',
      poster: item.poster || item.cover || '',
      added: item.added || 0,
      recentlyAddedRank: item.recentlyAddedRank ?? null,
      platformId,
    };
  }).filter((item) => hasOnlyLatinTitleLetters(item.title));

  if (!normalizedSeries.length) return SERIES_PLATFORMS;

  return SERIES_PLATFORMS.map((platform) => {
    const newestPlatformSeries = sortSeriesNewestFirst(
      normalizedSeries.filter((item) => item.platformId === platform.id)
    );

    if (!newestPlatformSeries.length) return platform;

    return {
      ...platform,
      series: newestPlatformSeries.slice(0, 5),
      posterSeries: newestPlatformSeries.filter((item) => Boolean(item.poster)).slice(0, 3),
      hasLiveSeries: true,
    };
  });
};

function SeriesPosterCard({ series, index, disableSkeleton = false }) {
  const [imageLoaded, setImageLoaded] = useState(disableSkeleton || !series.poster);
  const imageRef = useRef(null);
  const revealTimeoutRef = useRef(null);

  useEffect(() => {
    setImageLoaded(disableSkeleton || !series.poster);

    if (!disableSkeleton && series.poster && imageRef.current?.complete) {
      revealTimeoutRef.current = window.setTimeout(() => setImageLoaded(true), 160);
    }

    return () => {
      if (revealTimeoutRef.current) window.clearTimeout(revealTimeoutRef.current);
    };
  }, [disableSkeleton, series.poster]);

  const revealPoster = () => {
    if (revealTimeoutRef.current) window.clearTimeout(revealTimeoutRef.current);
    revealTimeoutRef.current = window.setTimeout(() => setImageLoaded(true), 280);
  };

  const posterClassName = [
    'tvup-series-poster',
    `poster-${index + 1}`,
    series.poster ? 'has-poster' : '',
    disableSkeleton ? 'no-skeleton' : '',
    series.poster ? (imageLoaded ? 'is-loaded' : 'is-loading') : '',
  ].filter(Boolean).join(' ');

  return (
    <article className={posterClassName}>
      {series.poster ? (
        <img
          ref={imageRef}
          src={series.poster}
          alt=""
          loading="eager"
          decoding="async"
          referrerPolicy="no-referrer"
          onLoad={revealPoster}
          onError={revealPoster}
        />
      ) : null}
      <span>{String(index + 1).padStart(2, '0')}</span>
      <div><small>{series.meta}</small><b>{series.title}</b></div>
    </article>
  );
}

function UserPanelHomeShowcases({
  series = [],
  seriesLoading = false,
  onOpenSeries,
  onOpenSetup,
  disabled = false,
}) {
  const [activeSeriesId, setActiveSeriesId] = useState(SERIES_PLATFORMS[0].id);
  const [activeAppId, setActiveAppId] = useState(APP_PLATFORMS[0].id);
  const [appVisualEntered, setAppVisualEntered] = useState(false);
  const [seriesDeckVisible, setSeriesDeckVisible] = useState(false);
  const seriesVisualRef = useRef(null);
  const appStageRef = useRef(null);

  const seriesPlatforms = useMemo(
    () => buildSeriesShowcasePlatforms(series),
    [series]
  );

  const activeSeries = useMemo(
    () => seriesPlatforms.find((platform) => platform.id === activeSeriesId) || seriesPlatforms[0],
    [activeSeriesId, seriesPlatforms]
  );
  const activeApp = useMemo(
    () => APP_PLATFORMS.find((platform) => platform.id === activeAppId) || APP_PLATFORMS[0],
    [activeAppId]
  );
  const ActiveAppIcon = activeApp.icon;
  const activateApp = (nextId) => {
    setAppVisualEntered(false);
    setActiveAppId(nextId);
  };

  useEffect(() => {
    setAppVisualEntered(false);
    const enterTimer = window.setTimeout(() => setAppVisualEntered(true), 110);
    return () => window.clearTimeout(enterTimer);
  }, [activeAppId]);

  useEffect(() => {
    const visual = seriesVisualRef.current;
    if (!visual) return undefined;

    if (!('IntersectionObserver' in window)) {
      setSeriesDeckVisible(true);
      return undefined;
    }

    const observer = new window.IntersectionObserver(
      ([entry]) => setSeriesDeckVisible(entry.isIntersecting),
      { threshold: 0.56, rootMargin: '0px 0px -16% 0px' }
    );

    observer.observe(visual);
    return () => observer.disconnect();
  }, []);

  useLayoutEffect(() => {
    const stage = appStageRef.current;
    if (!stage) return undefined;
    const scrollArea = stage.closest('.tvup-scroll-area');
    const scrollTarget = scrollArea || window;

    let frameId = 0;
    let currentOffset = 330;
    let targetOffset = 330;

    const readPhoneTarget = () => {
      const stageTop = stage.getBoundingClientRect().top;
      const scrollViewport = scrollArea?.getBoundingClientRect();
      const viewportTop = scrollViewport?.top || 0;
      const viewportHeight = scrollViewport?.height || window.innerHeight;
      const startPoint = viewportTop + (viewportHeight * 0.86);
      const endPoint = viewportTop + (viewportHeight * 0.12);
      const progress = Math.min(1, Math.max(0, (startPoint - stageTop) / (startPoint - endPoint)));
      const easedProgress = progress * progress * (3 - (2 * progress));

      targetOffset = (1 - easedProgress) * 330;
    };

    const animatePhonePosition = () => {
      const distance = targetOffset - currentOffset;
      currentOffset += distance * 0.085;
      stage.style.setProperty('--tvup-phone-offset', `${currentOffset.toFixed(2)}px`);

      if (Math.abs(distance) < 0.15) {
        currentOffset = targetOffset;
        stage.style.setProperty('--tvup-phone-offset', `${currentOffset.toFixed(2)}px`);
        frameId = 0;
        return;
      }

      frameId = window.requestAnimationFrame(animatePhonePosition);
    };

    const requestPhonePositionUpdate = () => {
      readPhoneTarget();
      if (!frameId) frameId = window.requestAnimationFrame(animatePhonePosition);
    };

    readPhoneTarget();
    const shouldEnterFromBottom = activeAppId === 'android' || activeAppId === 'ios';
    currentOffset = shouldEnterFromBottom ? 330 : targetOffset;
    stage.style.setProperty('--tvup-phone-offset', `${currentOffset.toFixed(2)}px`);
    if (shouldEnterFromBottom) {
      frameId = window.requestAnimationFrame(animatePhonePosition);
    }
    scrollTarget.addEventListener('scroll', requestPhonePositionUpdate, { passive: true });
    window.addEventListener('resize', requestPhonePositionUpdate);

    return () => {
      if (frameId) window.cancelAnimationFrame(frameId);
      scrollTarget.removeEventListener('scroll', requestPhonePositionUpdate);
      window.removeEventListener('resize', requestPhonePositionUpdate);
    };
  }, [activeAppId]);

  return (
    <div className={`tvup-home-showcases${disabled ? ' is-disabled' : ''}`}>
      <section className="tvup-discovery-section tvup-series-discovery" aria-labelledby="tvup-series-showcase-title">
        <header className="tvup-showcase-heading">
          <div>
            <h2 id="tvup-series-showcase-title">En sevdiğin diziler, Tivigo'da.</h2>
          </div>
          <p>
            Onlarca platforma ayrı ayrı ödeme yapmayın. Tüm popüler içerikler, tek bir Tivigo üyeliğinde.
          </p>
        </header>

        <div
          className="tvup-series-showcase"
          style={{ '--tvup-showcase-accent': activeSeries.color, '--tvup-showcase-accent-rgb': activeSeries.rgb }}
          aria-busy={seriesLoading ? 'true' : undefined}
        >
          <div className="tvup-series-tabs" role="tablist" aria-label="Dizi platformları">
            {seriesPlatforms.map((platform) => {
              const selected = activeSeriesId === platform.id;
              return (
                <button
                  key={platform.id}
                  type="button"
                  role="tab"
                  aria-selected={selected}
                  aria-controls="tvup-series-platform-panel"
                  tabIndex={selected ? 0 : -1}
                  className={selected ? 'is-active' : ''}
                  disabled={disabled}
                  title={disabled ? 'Hesabınız yeniden aktif olduğunda bu özellik kullanılabilir.' : undefined}
                  onClick={disabled ? undefined : () => setActiveSeriesId(platform.id)}
                  onKeyDown={disabled ? undefined : (event) => handleTabKeyDown(event, seriesPlatforms, activeSeriesId, setActiveSeriesId)}
                >
                  <span style={{ '--tvup-tab-color': platform.color }}>{platform.mark}</span>
                  <b>{platform.name}</b>
                  <small>{platform.subtitle}</small>
                </button>
              );
            })}
          </div>

          <div className="tvup-series-stage" id="tvup-series-platform-panel" role="tabpanel" aria-live="polite">
            <div className="tvup-series-copy">
              <h3>
                {(activeSeries.titleLines || [activeSeries.title]).map((line, index) => (
                  <React.Fragment key={line}>
                    {index > 0 ? <br /> : null}
                    {line}
                  </React.Fragment>
                ))}
              </h3>
              <ul>
                {activeSeries.series.slice(0, 5).map((series, index) => (
                  <li key={series.id || `${series.title}-${index}`}>
                    <span>{String(index + 1).padStart(2, '0')}</span>
                    <b>{series.title}</b>
                    <small>{series.meta}</small>
                  </li>
                ))}
              </ul>
              <button className="tvup-showcase-cta" type="button" disabled={disabled} title={disabled ? 'Hesabınız yeniden aktif olduğunda bu özellik kullanılabilir.' : undefined} onClick={disabled ? undefined : () => onOpenSeries?.(activeSeries.id)}>
                {activeSeries.name} kategorisine git <span aria-hidden="true">→</span>
              </button>
            </div>

            <div ref={seriesVisualRef} className={`tvup-series-visual${seriesDeckVisible ? ' is-revealed' : ''}`} aria-hidden="true">
              <div className="tvup-series-brand"><b>{activeSeries.brand}</b><span><i /> ÖNE ÇIKAN DİZİLER</span></div>
              <div className="tvup-series-deck">
                {(activeSeries.posterSeries || activeSeries.series.filter((item) => Boolean(item.poster)).slice(0, 3)).map((series, index) => (
                  <SeriesPosterCard
                    key={series.id || `${series.title}-${index}`}
                    series={series}
                    index={index}
                    disableSkeleton={!activeSeries.hasLiveSeries && activeSeries.id === 'netflix'}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="tvup-discovery-section tvup-apps-discovery" aria-labelledby="tvup-app-showcase-title">
        <header className="tvup-showcase-heading">
          <div>
            <h2 id="tvup-app-showcase-title">Tivigo'da hepsi bir arada.</h2>
          </div>
          <p>
            Tivigo, birçok popüler televizyon ve mobil platformda kendi resmi uygulamalarını kullanır.
          </p>
        </header>

        <div
          className="tvup-app-showcase"
          style={{ '--tvup-showcase-accent': activeApp.color, '--tvup-showcase-accent-rgb': activeApp.rgb }}
        >
          <div className="tvup-app-tabs" role="tablist" aria-label="Tivigo uygulamaları">
            {APP_PLATFORMS.map((platform, index) => {
              const AppIcon = platform.icon;
              const selected = activeAppId === platform.id;
              return (
                <button
                  key={platform.id}
                  type="button"
                  role="tab"
                  aria-selected={selected}
                  aria-controls="tvup-app-platform-panel"
                  tabIndex={selected ? 0 : -1}
                  className={selected ? 'is-active' : ''}
                  disabled={disabled}
                  title={disabled ? 'Hesabınız yeniden aktif olduğunda bu özellik kullanılabilir.' : undefined}
                  onClick={disabled ? undefined : () => activateApp(platform.id)}
                  onKeyDown={disabled ? undefined : (event) => handleTabKeyDown(event, APP_PLATFORMS, activeAppId, activateApp)}
                >
                  <span>{String(index + 1).padStart(2, '0')}</span>
                  <AppIcon />
                  <b>{platform.name}</b>
                  <small>{platform.subtitle}</small>
                </button>
              );
            })}
          </div>

          <div ref={appStageRef} className="tvup-app-stage" id="tvup-app-platform-panel" role="tabpanel" aria-live="polite">
            <div className="tvup-app-copy">
              <span>{activeApp.counter}</span>
              <h3>{activeApp.title}</h3>
              <p>{activeApp.description}</p>
              <ul>
                {activeApp.points.map((point) => <li key={point}><i /> {point}</li>)}
              </ul>
              <button
                className="tvup-showcase-cta tvup-app-download"
                type="button"
                disabled={disabled || activeApp.comingSoon || !activeApp.setupDetailId}
                title={disabled ? 'Hesabınız yeniden aktif olduğunda bu özellik kullanılabilir.' : undefined}
                onClick={disabled ? undefined : () => onOpenSetup?.(activeApp.setupDetailId)}
              >
                <ActiveAppIcon /> {activeApp.cta} {!activeApp.comingSoon && <DownloadRoundedIcon />}
              </button>
            </div>

            <div key={activeApp.id} className={`tvup-app-visual is-${activeApp.id}${activeApp.mobile ? ' is-mobile' : ''}${activeApp.tour ? ' is-tour' : ''}${activeApp.id === 'lg' ? ' is-tv' : ''}${appVisualEntered ? ' is-entered' : ''}`}>
              <div className="tvup-app-visual-glow" aria-hidden="true" />
              <figure className="tvup-app-screen-main">
                <div className="tvup-app-screen-chrome"><span><i /><i /><i /></span><b>Tivigo · {activeApp.name}</b><small>● CANLI</small></div>
                <div
                  className="tvup-app-screen-main-media"
                  style={{ aspectRatio: activeApp.mainRatio || `${activeApp.mainSize[0]} / ${activeApp.mainSize[1]}` }}
                >
                  {activeApp.mediaType === 'video' ? (
                    <video
                      key={`${activeApp.id}-${activeApp.main}`}
                      src={activeApp.main}
                      poster={activeApp.poster}
                      width={activeApp.mainSize[0]}
                      height={activeApp.mainSize[1]}
                      aria-label={`Tivigo ${activeApp.name} uygulama turu`}
                      autoPlay
                      muted
                      loop
                      playsInline
                      preload="metadata"
                    />
                  ) : (
                    <img
                      key={`${activeApp.id}-${activeApp.main}`}
                      src={activeApp.main}
                      width={activeApp.mainSize[0]}
                      height={activeApp.mainSize[1]}
                      alt={`Tivigo ${activeApp.name} uygulamasının ana ekranı`}
                      loading="lazy"
                      decoding="async"
                    />
                  )}
                </div>
                <figcaption><span>{activeApp.mainLabel}</span><b>01</b></figcaption>
              </figure>
              {activeApp.detailOne && (
                <figure className="tvup-app-screen-detail detail-one">
                  <div
                    className="tvup-app-screen-detail-media"
                    style={{ aspectRatio: `${activeApp.detailOneSize[0]} / ${activeApp.detailOneSize[1]}` }}
                  >
                    <img
                      src={activeApp.detailOne}
                      width={activeApp.detailOneSize[0]}
                      height={activeApp.detailOneSize[1]}
                      alt={`Tivigo ${activeApp.name} film detay ekranı`}
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                  <figcaption><span>{activeApp.detailOneLabel}</span><b>02</b></figcaption>
                </figure>
              )}
              {activeApp.detailTwo && (
                <figure className="tvup-app-screen-detail detail-two">
                  <div
                    className="tvup-app-screen-detail-media"
                    style={{ aspectRatio: `${activeApp.detailTwoSize[0]} / ${activeApp.detailTwoSize[1]}` }}
                  >
                    <img
                      src={activeApp.detailTwo}
                      width={activeApp.detailTwoSize[0]}
                      height={activeApp.detailTwoSize[1]}
                      alt={`Tivigo ${activeApp.name} dizi detay ekranı`}
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                  <figcaption><span>{activeApp.detailTwoLabel}</span><b>03</b></figcaption>
                </figure>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default UserPanelHomeShowcases;
